import React, { FC } from 'react';

import styled from '@emotion/styled';
import { Button, ButtonProps } from 'src/shared/ds/components/Button';
import { pxToRem } from 'src/shared/helpers/pxToRem';

const Container = styled.div<{ marginTop: string }>(({ marginTop }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'stretch',
    marginTop,
}));

export enum ButtonGroupTestID {
    FirstButton = 'ButtonGroupTestID.FirstButton',
    SecondButton = 'ButtonGroupTestID.SecondButton',
}

interface ButtonGroupProps {
    onFirstButtonClick: () => void;
    onSecondButtonClick: () => void;
    firstButtonText: string;
    secondButtonText: string;
    secondButtonDisabled?: boolean;
    firstButtonLoading?: boolean;
    secondButtonLoading?: boolean;
    firstButtonVariant?: ButtonProps['variant'];
    secondButtonVariant?: ButtonProps['variant'];
    firstButtonSize?: ButtonProps['size'];
    secondButtonSize?: ButtonProps['size'];
    firstButtonTestId?: string;
    secondButtonTestId?: string;
    marginTop?: number;
}

export enum ButtonGroupTestID {
    SubmitButton = 'ButtonGroupTestID.SubmitButton',
    CancelButton = 'ButtonGroupTestID.CancelButton',
}

export const ButtonGroup: FC<ButtonGroupProps> = ({
    firstButtonText,
    secondButtonText,
    onFirstButtonClick,
    onSecondButtonClick,
    secondButtonDisabled,
    marginTop = 0,
    firstButtonLoading = false,
    secondButtonLoading = false,
    firstButtonVariant = 'secondary',
    secondButtonVariant = 'primary',
    firstButtonSize = 'large',
    secondButtonSize = 'large',
    firstButtonTestId = ButtonGroupTestID.FirstButton,
    secondButtonTestId = ButtonGroupTestID.SecondButton,
}) => {
    return (
        <Container marginTop={pxToRem(marginTop)}>
            <Button
                title={firstButtonText}
                onClick={onFirstButtonClick}
                variant={firstButtonVariant}
                size={firstButtonSize}
                testID={firstButtonTestId}
                loading={firstButtonLoading}
                fullWidth
            />
            <Button
                title={secondButtonText}
                onClick={onSecondButtonClick}
                variant={secondButtonVariant}
                size={secondButtonSize}
                marginLeft={12}
                disabled={secondButtonDisabled}
                testID={secondButtonTestId}
                loading={secondButtonLoading}
                fullWidth
            />
        </Container>
    );
};
